module.exports = __webpack_public_path__ + "static/media/Line 46.4a560ada.svg";